export default "__VITE_ASSET__f6c21bf3__"